import { ajaxService } from '../../common/Services';
import { ApiUtils } from '../../common/api';
import DataSourceCollection from './data-source-collection';
import AdobeAttributesCollection from './adobe-attributes-collection';

/**
 * fetchDataSource - Returns a list for dropdowns from the generic data source endpoint, this often uses a custom URL to grab credentials data for integrations such as EMMA, Adobe or Campaign Monitor. These integrations often have a custom endpoint, but their return pattern is often the same
 */
function fetchDataSource(url) {
  return ajaxService
    .get(url)
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract)
    .then(DataSourceCollection.deserialize)
    .catch((error) => ({ error }));
}

function fetchAdobeAttributes(id) {
  return ajaxService
    .get('/api/external/adobecommerce/attributes', { credentialsId: id })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract)
    .then(AdobeAttributesCollection.deserialize)
    .catch((error) => ({ error }));
}

export default {
  fetchDataSource,
  fetchAdobeAttributes,
};
